import * as React from 'react';
import WordCloud from './word_cloud';
import { message } from 'antd';
// var echarts = require('echarts');
class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      selectMenu: null,
      menus: [],
      selectedObj: null,
      word_cloud: [],
    };
  }
  UNSAFE_componentWillMount() {
    // console.log('this.props.data', this.props.data);
    if (this.props.data) {
      this.setState({
        data: this.props.data,
        selectedObj: this.props.selectedObj,
        selectMenu: this.props.selectedObj.label
      }, () => {
        this.findMenu();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.data !== this.props.data) {
      this.setState({
        data: this.props.data,
        selectedObj: this.props.selectedObj,
        selectMenu: this.props.selectedObj.label
      }, () => {
        this.findMenu();
      });
    }
  }

  // 查找要显示的内容
  findMenu = () => {
    let content = this.state.data.content;
    let selectedObj = this.state.selectedObj;
    if (!content || content.length <= 0 || !selectedObj) {
      // console.log('数据有误!');
      message.error('数据有误!')
      return;
    }
    // console.log('content: ', content);
    if (content && content.length > 0) {
      // 组装左侧菜单
      this.setState(
        {
          menus: content,
        }, () => {
          this.findWordCloud();
        });
    }
  }

  todIndex = () => {
    this.props.todIndex();
  }
  selectedMenu = (v) => {
    this.setState({ selectMenu: v.label, selectedObj: v }, () => {
      this.findWordCloud();
    });
  }
  findWordCloud = () => {
    let selectedObj = this.state.selectedObj;
    let content = selectedObj.content;
    let findword_cloud = content.find(v => { return v.label === 'wordcloud_ele' });
    if (findword_cloud && findword_cloud.content && findword_cloud.content.length > 0) {
      let findwordcloud = findword_cloud.content.find(y => { return y.label === 'wordcloud' });
      if (findwordcloud) {
        if (findwordcloud && findwordcloud.content && findwordcloud.content.data && findwordcloud.content.data.length > 0) {
          let originData = findwordcloud.content.data;
          originData = originData.map(v => { return { name: v[0], value: v[1] } });

          this.setState({ word_cloud: originData }, () => {
            // console.log('word_cloud: ', this.state.word_cloud);
          });
        }
      }
    }
  }
  render() {
    const { menus, selectedObj } = this.state;
    // console.log('selectedObj: ', selectedObj);
    // 查找title
    const findTitle = () => {
      let title = null;
      const { selectedObj } = this.state;
      if (selectedObj && selectedObj.content && selectedObj.content.length > 0) {
        let title_ele = selectedObj.content.find(v => { return v.label === 'title_ele' });
        if (title_ele && title_ele.content && title_ele.content.length > 0) {
          title = title_ele.content.find(v => { return v.label === 'title' })?.content;
        }
      }
      return title;
    };
    // 查找文本段落 动态的(截取selectedObj.content的第二条开始 到倒数第3条) 多条文本段落数据
    const findCenterTexts = () => {
      const { selectedObj, } = this.state;
      let list = [];
      if (selectedObj && selectedObj.content && selectedObj.content.length > 0) {
        // 截取第二条开始到倒数第3条的数据
        let slices = selectedObj.content.slice(1, selectedObj.content.length - 1);
        let slicesContents = [];
        if (slices && slices.length > 0) {
          for (let index = 0; index < slices.length; index++) {
            const sl = slices[index];
            if (sl.content && sl.content.length > 0) {
              slicesContents = slicesContents.concat(sl.content);
            }
          }
        }
        if (slicesContents && slicesContents.length > 0) {
          for (let index = 0; index < slicesContents.length; index++) {
            const v = slicesContents[index];
            if (v.label === 'text') {
              list.push(
                <div key={index}>
                  <div style={{ fontWeight: '600' }}>{v.label_disp}</div>
                  <p style={{ lineHeight: '0.32rem' }}>{v.content}</p>
                </div>
              );
            }
          }
        }
      }
      // return list;
      return list;
    };

    // 查找词云图后的文本 固定是selectedObj.content最后一条
    const findCloudText = () => {
      let returnText = '';
      if (selectedObj && selectedObj.content && selectedObj.content.length > 0) {
        // 取最后一条
        let word_ills_ele = selectedObj.content[selectedObj.content.length - 1];
        if (word_ills_ele && word_ills_ele.content && word_ills_ele.content.length > 0) {
          returnText = word_ills_ele.content[0].content;
        }
      }
      return returnText;
    }
    return (
      <React.Fragment>
        {
          menus && menus.length > 0 &&
          <React.Fragment>
            <div className="left">
              <div className="back" onClick={this.todIndex}></div>
              <div className="child-menu-item">{this.props.leftTitle}</div>
              {
                menus.map((v) => {
                  return <div key={v.label} className={"child-menu-item" + (this.state.selectMenu === v.label ? ' selected' : '')} onClick={() => { this.selectedMenu(v); }}>{v.label}</div>;
                })
              }
            </div>
            {
              this.state.selectedObj &&
              <div div className="right">
                <div className="title">{selectedObj.label_disp}</div>
                <div className="title" style={{ fontSize: '0.2rem' }}>{findTitle()}</div>
                <div className="cnt">
                  <React.Fragment>
                    {
                      findCenterTexts()
                    }
                    {/* <p>Adenylosuccinate Lyase, The protein encoded by this gene belongs to the lyase 1 family. It is an essential enzymeinvolved in purine metabolism, and catalyzes two non-sequential reactions in the de novo purine biosynthetic pathway: theconversion of succinylaminoimidazole carboxamide ribotide (SAICAR) to aminoimidazole carboxamide ribotide (AICAR)and the conversion of adenylosuccinate (S-AMP) to adenosine monophosphate (AMP). Mutations in this gene are associated with adenylosuccinase deficiency (ADSLD), a disorder marked with psychomotor retardation, epilepsy orautistic features. Alternatively spliced transcript variants have been found for this gene. [provided by RefSeq, Dec 2015] ADSL Entities representing context (ERC) associated with ADSL(sorted by distance)cerebral,ganglia,hemispheres,cerebellar,creatine,corpus,resonance,magnetic,cerebellum,interhemispheric,glx,innervation,amnesia,cannabidiol,remedial,tbss,morphometric,spinocerebellar,voles,crus,globus,vbm,anatomic,pallidus,pfc,frontostriatal,rostral,naa,laminar,handedness,striatal,memories,ofc,dti,hemispheric,neuroanatomy,reinforcing,accumbens,orbitofrontal,purkinje,reinforced,neocortex,overgrowth,lobes,nuclei,hemisphere,sulcus,anisotropy,morphometry,radial,dorsal,tensor,anatomical,neuroanatomical,cortex,palsy,limbic,reinforcement,medial,amygdala,prefrontal,frontal,ganglion 表面上基因的功能可以被定义的很明确，并收录在数据库中，实际上相同基因在不同研究领域中其实扮演角色大不相同。因此TWIRLS给出当前基因在当前类别内容中关联最密切的ERC实体，这些实体代表的客观对象能够帮助研究者更好理解当前基因在特定条件下的功能角色。 Entities representing context (ERC) associated with ADSL(sorted by distance)cerebral,ganglia,hemispheres,cerebellar,creatine,corpus,resonance,magnetic,cerebellum,interhemispheric,glx,innervation,amnesia,cannabidiol,remedial,tbss,morphometric,spinocerebellar,voles,crus,globus,vbm,anatomic,pallidus,pfc,frontostriatal,rostral,naa,laminar,handedness,striatal,memories,ofc,dti,hemispheric,neuroanatomy,reinforcing,accumbens,orbitofrontal,purkinje,reinforced,neocortex,overgrowth,lobes,nuclei,hemisphere,sulcus,anisotropy,morphometry,radial,dorsal,tensor,anatomical,neuroanatomical,cortex,palsy,limbic,reinforcement,medial,amygdala,prefrontal,frontal,ganglion Entities representing context (ERC) associated with ADSL(sorted by distance)cerebral,ganglia,hemispheres,cerebellar,creatine,corpus,resonance,magnetic,cerebellum,interhemispheric,glx,innervation,amnesia,cannabidiol,remedial,tbss,morphometric,spinocerebellar,voles,crus,globus,vbm,anatomic,pallidus,pfc,frontostriatal,rostral,naa,laminar,handedness,striatal,memories,ofc,dti,hemispheric,neuroanatomy,reinforcing,accumbens,orbitofrontal,purkinje,reinforced,neocortex,overgrowth,lobes,nuclei,hemisphere,sulcus,anisotropy,morphometry,radial,dorsal,tensor,anatomical,neuroanatomical,cortex,palsy,limbic,reinforcement,medial,amygdala,prefrontal,frontal,ganglion</p> */}
                    {/* <div className="word-chart">词云图</div> */}
                    {
                      this.state.word_cloud && this.state.word_cloud.length > 0 &&
                      <WordCloud word_cloud={this.state.word_cloud} />
                    }
                    <p>{findCloudText()}</p>
                  </React.Fragment>
                </div>
              </div>
            }
          </React.Fragment>
        }
      </React.Fragment>
    );
  }
}

export default Summary;